import Skeleton from 'react-loading-skeleton'

const VideoTalentCardSkeleton = () => {
  return <Skeleton containerClassName='tm-talent-container gap-3' count={12} width={300} height={282} />
}

export default VideoTalentCardSkeleton
